import { gql } from '@apollo/client';

const MOVE_HELP_TOPIC = gql`mutation moveHelpTopic($input: MoveHelpTopicInput!) {
  helpContext {
    moveHelpTopic(input: $input) {
			success
			message
			topic {
				topicId: id
				parentTopicId: parentId
				index
				title: name
				description
			}
    }
  }
}`;

export default MOVE_HELP_TOPIC;
